import { Divider } from 'antd';
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import styles from './styles.module.less';

const Card = ({ children, footer, className, floatingCardClassName = '' }) => {
  return (
    <div className={classnames(styles.mainContainer, className)}>
      <div className={classnames(styles.floatingCard, floatingCardClassName)}>
        <div className={styles.content}>{children}</div>
        {footer && (
          <>
            <Divider />
            <div className={styles.footer}>{footer}</div>
          </>
        )}
      </div>
    </div>
  );
};

Card.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  className: PropTypes.string,
  floatingCardClassName: PropTypes.string,
  footer: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
};

Card.defaultProps = {
  className: '',
  floatingCardClassName: '',
  footer: null,
};

export default Card;
